import {ListJobsCrew} from '@api/model';

/**
 * Internal staff, or a visitor (subcontractor). The jobs list filters on it
 * (`?crew=`, the API's `crew` param) and the assignee pickers group by it.
 * Derived from the generated enum, so a kind the API adds arrives here too.
 */
export type CrewKind = NonNullable<ListJobsCrew>;

export const CREW_KINDS: ReadonlyArray<CrewKind> = Object.values(ListJobsCrew);

/** The jobs list's "Involves" filter wording. */
export const CREW_KIND_LABEL: Record<CrewKind, string> = {
  staff: 'Internal staff',
  visitor: 'Visitors',
};

export function parseCrewKind(value: unknown): CrewKind | undefined {
  return CREW_KINDS.find((kind) => kind === value);
}
